/**
 * Filter function used to filter out statuses in Comms management page.
 */
(function() {
    'use strict';

    angular.module('app').filter('statusFilter', function() {

        return function(input, statuses) {
            if (!statuses || statuses.length === 0) return input;
            var out = [];
            angular.forEach(input, function (item) {
                angular.forEach(statuses, function (status) {
                    if(item.statusKey){
                        if (item.statusKey === status.type) {
                            out.push(item);
                        }
                    }
                });
            });
            return out;
        }
    });

}());